import { useAppState } from 'client/providers/AppProvider';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import { Content_File, Espin_Game_Definition_Enum, Espin_Role_Enum } from '../../../../generated/spin-graphql';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';

type Props = {
    data: SocialCardData;
    //seletion for a primary child should maybe be part of global state, idk
    // selectedChild?: number;
};

export type SocialCardData = {
    label: string;
    subLabel: string;
    picAltText: string;
    profileImg: Partial<Content_File>;
    slug: string;
    unread: boolean;
    getPrimaryGame?: Espin_Game_Definition_Enum | null;
    primaryGameName?: string | null;
    hasGraduatingClass?: boolean;
    graduatingYear?: string;
    isParent?: boolean;
    collegeName?: string;
    deletedUser: boolean;
    subTierRequired?: number;
};

export const SocialCard: React.FC<Props> = ({ data }) => {
    const router = useRouter();
    const { user, subscribed, subtier } = useAppState();

    const subtierMatched = useMemo(() => {
        return (
            user.role === Espin_Role_Enum.EspinHighschoolUser ||
            (subscribed && ((data.subTierRequired && subtier >= data.subTierRequired) || !!!data.subTierRequired))
        );
    }, [subscribed, data.subTierRequired, subtier, user.role]);

    return (
        <div
            onClick={() => router.push(subtierMatched ? data.slug : '/dashboard/subscriptions')}
            className="notification-card"
        >
            {/* <PictureWithFallback
                    width={40}
                    height={40}
                    icon={playerUserInfo?.player_user?.player_profile.profile_image}
                    alt={`${playerUserInfo?.player_user?.player_profile?.first_name}'s picture`}
                /> */}

            <div className="image-wrapper">
                <PictureWithFallback
                    width={40}
                    height={40}
                    icon={data.deletedUser ? null : data.profileImg}
                    alt={data.deletedUser ? 'Deleted User' : data.picAltText}
                />
            </div>
            <div className="user-info">
                <h2 className="user-label">
                    {data.label}
                    {/* {subscribed ? (
                        <>
                            {' '}
                            {data.hasGraduatingClass && (
                                <span className="graduating-class">{` '${data?.graduatingYear
                                    .toString()
                                    .substring(2)}`}</span>
                            )}
                        </>
                    ) : null} */}
                </h2>
                {subtierMatched ? (
                    <div className="user-sublabel-container">
                        {/* {data.getPrimaryGame != null && (
                            <GameIcon game={data?.getPrimaryGame} gameName={data?.primaryGameName} />
                        )} */}
                        {data.collegeName ? <p className="user-sublabel">{data.collegeName}</p> : null}
                        {data.isParent ? (
                            <p className="user-sublabel">{data.deletedUser ? 'Deleted User' : data.subLabel}' Parent</p>
                        ) : (
                            <p className="user-sublabel">{data.deletedUser ? 'Deleted User' : data.subLabel}</p>
                        )}
                    </div>
                ) : null}
            </div>

            <div className="user-controls">
                {/* no messages implemented yet! */}
                {/* <Link href={`/dashboard/messages/${data.slug}`}>
                    <a className="button circle-button">
                        <MessageIcon />
                    </a>
                </Link> */}
                {subtierMatched ? null : (
                    <Link href="/dashboard/subscriptions">
                        <a className="button small-button blue-button">GET PREMIUM</a>
                    </Link>
                )}
            </div>
            {data.unread && <div className="notification-badge" />}
        </div>
    );
};
